// Mobile bottom navigation component - StockTwits inspired design
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-mobile-bottom-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  template: `
    <nav
      class="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 md:hidden"
    >
      <div class="flex justify-around items-center py-1 safe-area-pb">
        <a
          routerLink="/facts"
          routerLinkActive="text-primary dark:text-primary"
          [routerLinkActiveOptions]="{ exact: false }"
          class="flex flex-col items-center px-2 py-2 min-w-0 flex-1 text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors duration-200"
        >
          <svg
            class="w-6 h-6 mb-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="1.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <span class="text-xs font-medium">Facts</span>
        </a>

        <a
          routerLink="/media"
          routerLinkActive="text-primary dark:text-primary"
          class="flex flex-col items-center px-2 py-2 min-w-0 flex-1 text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors duration-200"
        >
          <svg
            class="w-6 h-6 mb-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="1.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
            ></path>
          </svg>
          <span class="text-xs font-medium">Media</span>
        </a>

        <a
          routerLink="/search"
          routerLinkActive="text-primary dark:text-primary"
          class="flex flex-col items-center px-2 py-2 min-w-0 flex-1 text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors duration-200"
        >
          <svg
            class="w-6 h-6 mb-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="1.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
            ></path>
          </svg>
          <span class="text-xs font-medium">Search</span>
        </a>

        <a
          routerLink="/stats"
          routerLinkActive="text-primary dark:text-primary"
          class="flex flex-col items-center px-2 py-2 min-w-0 flex-1 text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors duration-200"
        >
          <svg
            class="w-6 h-6 mb-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="1.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
            ></path>
          </svg>
          <span class="text-xs font-medium">Stats</span>
        </a>
      </div>
    </nav>
  `,
  styles: [
    `
      .safe-area-pb {
        padding-bottom: env(safe-area-inset-bottom, 0);
      }

      /* Chrome mobile specific fix */
      @supports (padding-bottom: max(0px)) {
        .safe-area-pb {
          padding-bottom: max(env(safe-area-inset-bottom, 0), 0px);
        }
      }
    `,
  ],
})
export class MobileBottomNavComponent {}
